import { useOrgContext } from '@/org/contexts/OrgContext'
import { CircleFragment } from '@gql'
import { useMemo } from 'react'
import useCurrentMember from './useCurrentMember'

// Circles the current member is a direct member of ("my roles"), used to scope
// role/circle pickers to the member's own roles (ORG-02).
export default function useMyRoles(): CircleFragment[] {
  const { orgData } = useOrgContext()
  const currentMember = useCurrentMember()

  return useMemo(
    () =>
      currentMember && orgData
        ? [...orgData.circlesOfMember(currentMember.id)]
        : [],
    [orgData, currentMember]
  )
}
